'use client'
import { useState } from "react";
import { ChevronDown, ChevronUp } from "@/assets/icons";
import { logout } from "@/app/api";
import { useRouter } from "next/navigation";
import { Button, SmartLink } from "@/components/ui";

export function ClientMenu() {
    const router = useRouter();
    const handleClick = async () => {
        try {
            const response = await logout();
            if (response.success) {
                router.push(`${process.env.NEXT_PUBLIC_PRIMARY_DOMAIN}`)
                router.refresh();
                setMenuClientOpen(false)
            }
        } catch (e) {
            console.log('Erro ao fazer logout:', e);
        }
    };
    const [menuClientOpen, setMenuClientOpen] = useState<boolean>(false);
    return (
        <div>
            <Button onClick={() => setMenuClientOpen(menuClientOpen ? false : true)}
                className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                <ChevronDown className={`size-6 ${menuClientOpen ? 'hidden' : 'flex'}`} />
                <ChevronUp className={`size-6 ${menuClientOpen ? 'flex' : 'hidden'}`} />
            </Button>

            <div className={`${menuClientOpen ? 'flex' : 'hidden'}`}>
                <div className="absolute flex flex-col mt-6 -ms-32 z-50 p-8 gap-6 rounded-md shadow-lg bg-silver-100 dark:bg-silver-500">

                    <SmartLink type={"internal"} route={"client"} onClick={() => setMenuClientOpen(false)}
                        className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                        Dashboard
                    </SmartLink>

                    <button className="cursor-pointer flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent" onClick={handleClick}>
                        <span>Sair</span>
                    </button>

                </div>
                <div onClick={() => setMenuClientOpen(false)} className="absolute w-screen h-screen top-0 left-0 z-30 cursor-pointer" />
            </div>
        </div>
    )
}